import React from 'react';

const FullWidthCard = ({
  children,
  className,
  reverse,
  colReverse,
  noGutters,
  key
}) => {
  return (
    <div className={`card--fw ${className}`} key={key}>
      <div className='card__content--fw'>
        <div
          className={`card__inner d-flex ${
            colReverse ? 'flex-column-reverse' : 'flex-column'
          } align-items-center ${
            reverse ? 'flex-sm-row-reverse' : 'flex-sm-row'
          } ${noGutters ? 'no-gutters' : ''}`}
        >
          {children}
        </div>
      </div>
    </div>
  )
};

export default FullWidthCard



// WEBPACK FOOTER //
// ./src/components/FullWidthCard/index.js